/** 
*@author: satyamurthy.a
*@Description : 
**/
import axios from 'axios';
import moment from 'moment';
import { connect } from 'react-redux';
import React, { useEffect, useState, useRef, useCallback } from 'react';
import Highlighter from 'react-highlight-words';
import { SearchOutlined } from '@ant-design/icons';
import localStorage from '../../../utils/localStorage';
import { Table_AppConfig } from '../../../commons/table';
import StyledTable from '../../../commons/styles/table';
import { API_MASTERCONFIGURATION, REPORTFRAMEWORK } from '../../../commons/api';
import { Form, Select, DatePicker, Button, message, Drawer, Input } from 'antd';

const { Option } = Select;
const { RangePicker } = DatePicker;

const CronReRun = (props) => {
  const [jobList, setJobList] = useState([]);
  const [jobName, setJobName] = useState('');
  const [range, setRange] = useState([]);
  const [listView, setListView] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [translationCache, setTranslationCache] = useState(props.translationCache || []);
  const searchInput = useRef(null);

  useEffect(() => {
    getJobList();
  }, []);

  useEffect(() => {
    setTranslationCache(props.translationCache);
  }, [props.translationCache]);

  const getJobList = useCallback(() => {
    const siteId = localStorage.get('currentSite');
    let accessToken = localStorage.get('accessToken');
    const healthheaders = {
      method: 'POST',
      url: `${API_MASTERCONFIGURATION.GETDROPDOWN}?SiteId=${siteId}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      },
      data: {
        TableName: Table_AppConfig.SiteMasterCronJobs,
        ColumnName: 'Name',
        Conditions: [
          {
            key: 'Rerun',
            value: true
          }
        ]
      }
    };
  
    axios(healthheaders)
      .then((res) => {
        setJobList(res.data);
      })
      .catch((error) => {
        if (error.response) {
          console.error('Error response:', error.response.data);
          console.error('Error status:', error.response.status);
          message.error(`Error: ${error.response.data.message || 'Failed to fetch job list. Please try again later.'}`);
        } else if (error.request) {
          console.error('Error request:', error.request);
          message.error('No response received from the server. Please check your network connection.');
        } else {
          console.error('Error message:', error.message);
          message.error('An unexpected error occurred. Please try again later.');
        }
      });
  }, []);

  const onChange = (value, dateString) => {
    const startDate = dateString[0] ? moment(dateString[0]).utc().format('YYYY-MM-DD HH:mm:ss') : '';
    const endDate = dateString[1] ? moment(dateString[1]).utc().format('YYYY-MM-DD HH:mm:ss') : '';
    setRange([startDate, endDate]);
  };

  const jobChange = (value) => {
    const selectedJob = jobList.find(jobItem => jobItem.Key === value);
    if (selectedJob) {
      setJobName(selectedJob.Key);
    }
  };

  const cronSubmit = () => {
    const { userProfile } = props;
    const userName = userProfile?.user?.UserName;
    let role = '';
    const userId = userProfile?.user?.Id;
    let roleId = '';

    userProfile?.belongsTo?.sites?.forEach(item => {
      role = item?.role?.Name;
      roleId = item?.role?.Id || '';
    });

    const payload = {
      cronName: jobName,
      cronType: 'Rerun',
      startDate: range[0],
      endDate: range[1],
      userName: userName,
      userId: userId,
      roleName: role,
      roleId: roleId
    };
    const siteId = localStorage.get('currentSite');
    let accessToken = localStorage.get('accessToken');
    const healthheaders = {
      method: 'POST',
      url: `${REPORTFRAMEWORK.ReRun}?SiteId=${siteId}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      },
      data: payload
    };
    axios(healthheaders)
      .then(() => {
        message.success('JOB Is Going To Be Run In Few Minutes');
      })
      .catch((error) => {
        message.error('Failed to submit job. Please try again later.',error);
      });
  };

  const historyShow = async (date) => {
    const start = moment(date).format('YYYY-MM-DD 00:00:00');
    const end = moment(date).format('YYYY-MM-DD 23:59:59');
    const siteId = localStorage.get('currentSite');
    let accessToken = localStorage.get('accessToken');
    const payload = {
      cronName: jobName,
      startDate: moment(start).utc().format('YYYY-MM-DD HH:mm:ss'),
      endDate: moment(end).utc().format('YYYY-MM-DD HH:mm:ss'),
      CronType: 'Rerun'
    };
    const healthheaders = {
      method: 'POST',
      url: `${REPORTFRAMEWORK.ReRunHistory}?SiteId=${siteId}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      },
      data: payload
    };
    axios(healthheaders)
      .then((respon) => {
        setDataSource(respon.data);
        setListView(true);
      })
      .catch((error) => {
        console.error('Error fetching job history:', error);
      });
  };

  const onCloseList = () => {
    setListView(false);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        {dataIndex === 'RunDate' ? (
          <DatePicker
            format="YYYY-MM-DD"
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={(value) => setSelectedKeys(value ? [value] : [])}
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
        ) : (
          <Input
            ref={searchInput}
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
        )}
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => handleReset(clearFilters)}  style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record && record[dataIndex] && dataIndex === 'Equipment'
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : record[dataIndex],
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });

  const handleSearch = (selectedKeys, confirm, column) => {
    confirm();
    if (column === 'RunDate') {
      setSearchText(moment(selectedKeys[0]).format('YYYY-MM-DD'));
    } else {
      setSearchText(selectedKeys[0]);
    }
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const disabledDate = (current) => {
    return current > moment().endOf('day');
  };

  const onDateChange = (date, dateString) => {
    historyShow(dateString);
  };

  const translation = (keyword) => {
    return translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const columns = [
    {
      title: 'ReportName',
      key: 'Name',
      dataIndex: 'Name'
    },
    {
      title: 'RunType',
      key: 'CronType',
      dataIndex: 'CronType'
    },
    {
      title: 'ReportDate',
      key: 'StartTime',
      dataIndex: 'StartTime'
    },
    {
      title: 'JobStatus',
      key: 'Status',
      dataIndex: 'Status'
    },
    {
      title: 'Remarks',
      key: 'Remarks',
      dataIndex: 'Remarks'
    },
    {
      title: 'RunDate',
      key: 'CronRunDate',
      dataIndex: 'CronRunDate',
      ...getColumnSearchProps('RunDate')
    }
  ];

  return (
    <div style={{ minHeight: window.innerHeight - 300 }}>
      <Button
        
        type={'primary'}
        style={{
          display: 'flex',
          marginLeft: 'auto',
          padding: '5px',
          order: 2
        }}
        onClick={() => historyShow(moment().format('YYYY-MM-DD'))}
      >
        {translation('Report Run History')}
      </Button>
      <Form
        style={{ marginTop: '40px' }}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        onFinish={cronSubmit}
      >
        <Form.Item
          label={translation('Select Report')}
          name="Select Report"
          rules={[{ required: true, message: 'Please Select CronJob' }]}
        >
          <Select
            placeholder={translation('PleaseSelect CronJob')}
            onSelect={jobChange}
            style={{ width: '350px' }}
          >
            {jobList.map((item) => (
              <Option key={item.Id} value={item.Key}>
                {item.Key}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label={translation('Date Range Selection')}
          name="Select Date"
          rules={[{ required: true, message: 'Please Select Date Selection' }]}
        >
          <RangePicker
            format="YYYY-MM-DD"
            placeholder={[translation('Start Date'), translation('End Date')]}
            onChange={onChange}
          />
        </Form.Item>
        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <Button  type={'primary'} htmlType="submit">
            {translation('Generate Report')}
          </Button>
        </Form.Item>
      </Form>

      <Drawer
        title="Cron Job History"
        width={1500}
        placement="right"
        closable={true}
        onClose={onCloseList}
        open={listView}
      >
        <div>
          <div
            style={{
              display: 'flex',
              fontWeight: 'bold',
              flexDirection: 'row-reverse'
            }}
          >
            <DatePicker
              style={{ width: 300 }}
              defaultValue ={moment()}
              disabledDate={disabledDate}
              onChange={onDateChange}
            />
            <div style={{ marginRight: '15px' }}>Select Date :</div>
          </div>
          <div style={{ marginTop: '10px' }}>
            <StyledTable size="small" columns={columns} dataSource={dataSource} />
          </div>
        </div>
      </Drawer>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    userProfile: state.LayoutReducer.getUserProfile,
    translationCache: state.TranslationReducer.translationCache,
  };
};

export default connect(mapStateToProps)(CronReRun);